import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideModalComponent } from './side-modal.component';
@NgModule({
  declarations: [SideModalComponent],
  imports: [CommonModule],
  exports: [SideModalComponent],
})
export class SideModalModule {}
